import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    TextField,
} from "@mui/material";
import styles from "./survey.module.css";
import React, { ChangeEvent } from "react";
import { useLocation } from "react-router-dom";
import { CheckBoxType, EnquiryClientInput } from "../../interface/form";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import {
    ChangeDisclaimerFromSurveyThunk,
    ChangeEmailThunk,
    ChangeIsOthersThunk,
    ChangeIsOverfilledThunk,
    ChangeNameThunk,
    ChangeOtherRemarkThunk,
    ChangeTelThunk,
} from "../../redux/EnquiryForm/thunk";

function SurveyBodyPageOne() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const locationCn = searchParams.get("location");
    const dispatch = useDispatch<IRootThunkDispatch>();
    const {
        disclaimer,
        name,
        tel,
        email,
        is_overfilled,
        is_others,
        othersRemark,
    } = useSelector((state: IRootState) => state.enquiryFormInfoState);

    function handleCheckBox(
        event: ChangeEvent<HTMLInputElement>,
        type: CheckBoxType
    ) {
        switch (type) {
            case "is_overfilled":
                dispatch(ChangeIsOverfilledThunk(event.target.checked));
                break;
            case "is_others":
                dispatch(ChangeIsOthersThunk(event.target.checked));
                break;
            case "disclaimer":
                dispatch(ChangeDisclaimerFromSurveyThunk(!disclaimer));
                break;
        }
    }

    function handleInput(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        infoType: EnquiryClientInput
    ) {
        switch (infoType) {
            case "name":
                dispatch(ChangeNameThunk(event.target.value));
                break;
            case "email":
                dispatch(ChangeEmailThunk(event.target.value));
                break;
            case "tel":
                dispatch(ChangeTelThunk(event.target.value));
                break;
            case "others_remarks":
                dispatch(ChangeOtherRemarkThunk(event.target.value));
                break;
        }
    }

    return (
        <Grid>
            <ol type="1" className={styles.OrderListContainer}>
                <li>
                    <Grid className={styles.QuestionContainer}>
                        <Grid>回收桶編號 Recycling Bin Code:</Grid>
                        <Grid>{code}</Grid>
                    </Grid>
                </li>

                <li>
                    <Grid className={styles.QuestionContainer}>
                        <Grid>回收桶位置 Recycling Bin Location:</Grid>
                        <Grid>{locationCn}</Grid>
                    </Grid>
                </li>

                <li>
                    <Grid className={styles.QuestionContainer}>
                        <Grid>意見/查詢 Opinion/Enquiry</Grid>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={is_overfilled}
                                        onChange={(event) =>
                                            handleCheckBox(
                                                event,
                                                "is_overfilled"
                                            )
                                        }
                                    />
                                }
                                label="回收桶滿溢 Recycle Bin Overfilled"
                                value="0"
                            />
                            <FormControlLabel
                                required
                                control={
                                    <Checkbox
                                        checked={is_others}
                                        onChange={(event) =>
                                            handleCheckBox(event, "is_others")
                                        }
                                    />
                                }
                                label="其他 Others"
                                value="1"
                            />

                            <TextField
                                id="outlined-multiline-flexible"
                                label="請解釋其他問題原因"
                                multiline
                                maxRows={4}
                                value={othersRemark}
                                onChange={(event) =>
                                    handleInput(event, "others_remarks")
                                }
                            />
                        </FormGroup>
                    </Grid>
                </li>
                <li>
                    <Grid className={styles.QuestionContainer}>
                        <Grid>聯絡資料 Contact Information</Grid>

                        <Grid className={styles.QuestionContainer}>
                            <FormLabel>姓名 Name</FormLabel>
                            <TextField
                                id="outlined-basic"
                                placeholder="請輸入名稱"
                                onChange={(event) => handleInput(event, "name")}
                                value={name}
                            />
                        </Grid>

                        <Grid className={styles.QuestionContainer}>
                            <FormLabel>電話 Tel</FormLabel>
                            <TextField
                                id="outlined-basic"
                                placeholder="例子：12345678"
                                onChange={(event) => handleInput(event, "tel")}
                                value={tel}
                                type="number"
                            />
                        </Grid>

                        <Grid className={styles.QuestionContainer}>
                            <FormLabel>電郵 Email</FormLabel>
                            <TextField
                                id="outlined-basic"
                                placeholder="例子：xxx@gmail.com"
                                onChange={(event) =>
                                    handleInput(event, "email")
                                }
                                value={email}
                                type={"email"}
                            />
                        </Grid>

                        <Grid className={styles.DisclaimerContainer}>
                            *
                            《收集個人資料聲明》：請注意，你可自願向本司提供你的個人資料。你提供的所有個人資料只會用於與本查詢/投訴直接有關的用途。你有權要求查閱及改正本司所持有你的個人資料。查閱或改正該等資料，可用書面向本司提出，地址為九龍荔枝角瓊林街93號龍翔工業大廈4樓A室。你所提供的個人資料可能轉移給本司因處理本個案而接觸的人士或機構，包括獲授權收取有關資料以跟進本個案的人士或機構。Personal
                            Information Collection Statement:Please be advised
                            that it is voluntary for you to supply to us your
                            personal data. All personal data submitted will only
                            be used for purposes which are directly related to
                            this opinion / complaint.You have the right to
                            request access to and correction of your personal
                            data held by us. Request for access or correction of
                            personal data should be made in writing to the Unit
                            A, 4/F, Dragon Industrial Building, No. 93 King Lam
                            Street, Lai Chi Kok, Kowloon.The personal data
                            submitted may be transferred to parties who will be
                            contacted by us during the handling of this case
                            includingthe party being complained against or other
                            parties concerned. The information provided may also
                            be disclosed to agencies who are authorized to
                            receive information relating to following up the
                            case.
                        </Grid>

                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event) =>
                                            handleCheckBox(event, "disclaimer")
                                        }
                                    />
                                }
                                label="同意 AGREE"
                            />
                        </FormGroup>
                    </Grid>
                </li>
            </ol>
        </Grid>
    );
}

export default SurveyBodyPageOne;
